export default __webpack_public_path__ + "static/media/4c.8ff0fa52.png";